// extracted by mini-css-extract-plugin
module.exports = {"totalPrice":"_220pz","totalPriceRow":"_22XzB"};